import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, icons } from '@/utils'

import button from '@/components/button'

export default function(h) {
  return h(
    button,
    {
      props: {
        icon: icons.open_in_new,
        color: Colors.secondary,
        mode: buttonModes.flat,
        tooltip: this.getTranslate(`${Services.sendings}.tooltips.goTo`, { service: this.getTranslate(`${this.service}.title`) })
      },
      on: {
        click: this.redirect
      }
    }
  )
}
